// @ts-expect-error not typed
import NotificationMiddleware from 'ReduxMessenger/middleware/NotificationMiddleware';
// @ts-expect-error not typed
import structuredContentModuleRefreshMiddleware from 'ContentEditorUI/redux/middleware/structuredContentModuleRefreshMiddleware';
// @ts-expect-error not typed
import { getAsyncComponents } from 'ContentEditorUI/components/AsyncComponents';
// @ts-expect-error not typed
import universalAppReadyMiddleware from 'ContentEditorUI/redux/middleware/universalAppReadyMiddleware';
import lang from 'i2l?query=sporks!knowledge-base-editor-ui/lang/en.lyaml';
// @ts-expect-error not typed
import { getStandardFetchCssRequestOptions } from 'ContentEditorUI/lib/scalableEditor/commonFeatureConfigs';
// @ts-expect-error not typed
import { makeAsyncComponent } from 'ContentEditorUI/components/shared/makeAsyncUtils';
import { getActiveHubDbRowId } from 'ContentEditorUI/redux/selectors/instanceEditingSelectors';
import { buildInitialInstanceEditingState } from 'structured-content-lib/redux/reducers/undoableInstanceEditingReducer';
import rhumbConfig from '../../../rhumb-config.yaml';
import hubDbColumnLabelAndDescriptionMiddleware from '../../middlewares/hubDbColumnLabelAndDescriptionMiddleware';
import { rootReducer } from '../../reducers';
import Routes from '../../routes/components/Routes';
import { save, autoSave, autoSaveDebounced } from '../actions/editorSaveActions';
import { getCanSave, getSaveData } from '../selectors/saveSelectors';
import { initialRequestActions } from '../actions/initalRequestActions';
import Placeholder from '../components/Placeholder';
import HeaderContainer from '../components/Header';
import ExtraApplicationContainerComponents from '../components/ExtraApplicationContainerComponents';
import RootTreeWrapper from '../components/RootTreeWrapper';
import { CommentObjectType, FEATURES, SUPPORTED_HUBS } from 'collaboration-sidebar';
import ExtraApplicationContainerApprovalsWrapper from '../components/ExtraApplicationContainerApprovalsWrapper';
import { ContentEditorCopilotCollaborationContextProvider } from 'ContentEditorUI/copilot/ContentEditorCopilotCollaborationContextProvider';
import { gate } from 'hub-http/gates';
const AsyncCampaignFieldContainer = makeAsyncComponent(() => import(
// @ts-expect-error not typed
/* webpackChunkName: 'CampaignFieldContainer' */
'ContentEditorUI/containers/settings/CampaignFieldContainer'));
const AsyncPreviewModal = makeAsyncComponent(() => import( /* webpackChunkName: 'PreviewModal' */'knowledge-base-editor-ui/editor/components/PreviewModal'));
const AsyncCollaborationSidebarContainer = makeAsyncComponent(() => import( /* webpackChunkName: 'collaboration-sidebar-container' */'ContentEditorUI/containers/CollaborationSidebarContainer'));
const AsyncRevisionHistoryContainer = makeAsyncComponent(() => import( /* webpackChunkName: 'RevisionHistoryContainer' */'../components/RevisionHistoryContainer'));
const makeInitialState = () => {
  // @ts-expect-error parseEditorUrl should exist on global
  const {
    articleId
  } = window.parseEditorUrl();
  const currentHubDbRowId = parseInt(articleId, 10);
  return {
    structuredContent: {
      instanceEditing: buildInitialInstanceEditingState({
        dataAuthoringModeActive: true,
        instanceEditingModeActive: true,
        currentHubDbRowId
      })
    }
  };
};
export const buildEditorConfig = userInfo => ({
  appKey: 'knowledge-article-editor',
  features: {
    cssAssets: {
      getFetchCssRequestOptions: getStandardFetchCssRequestOptions
    },
    templateTypes: true,
    shouldUseNopeZonesForAllModules: false,
    shouldFocusSingleStaticModule: false,
    hideLockedEditFormFields: false,
    breakpoints: true,
    undoRedo: true,
    sections: true,
    collaborationSidebar: {
      appName: 'knowledge-article-editor',
      enabledFeatures: [FEATURES.COMMENTS],
      mapStateToCollaborationSidebarConfig: state => ({
        objectId: getActiveHubDbRowId(state),
        objectType: CommentObjectType.KNOWLEDGE_ARTICLE,
        appHub: [SUPPORTED_HUBS.SERVICE_HUB]
      })
    },
    inlineStyles: true,
    smartContent: true,
    aiGeneratedContent: true,
    quickSpot: false,
    focusMode: true,
    moduleInsertion: false,
    copilotCollaboration: userInfo.gates.includes(gate('KB:Copilot:Collaborate')),
    universalThemeEditor: false
  },
  routes: Routes,
  // Selectors required for the core app to work
  redux: {
    reducers: {
      rootReducer
    },
    selectors: {
      getSaveData,
      getCanSave,
      getHasPermissionsToLoadEditor: () => true
    },
    actions: {
      save,
      autoSave,
      autoSaveDebounced
    },
    checkAppReadyMiddleware: universalAppReadyMiddleware(['FETCH_PORTAL_INFO_SUCCESS', 'FETCH_PORTAL_SCOPES_SUCCESS', 'FETCH_CONTENT_SCHEMA_SUCCEEDED', 'GET_CONTENT_ASSISTANT_SETTINGS', 'I18N_READY']),
    customMiddlewares: [structuredContentModuleRefreshMiddleware(), hubDbColumnLabelAndDescriptionMiddleware(), NotificationMiddleware],
    makeInitialState
  },
  components: {
    asyncComponents: getAsyncComponents({
      extraComponents: {
        CampaignFieldContainer: AsyncCampaignFieldContainer,
        CollaborationSidebarContainer: AsyncCollaborationSidebarContainer,
        PreviewModal: AsyncPreviewModal,
        RevisionHistory: AsyncRevisionHistoryContainer
      }
    }),
    HeaderExtension: HeaderContainer,
    TabBarExtension: Placeholder,
    SidebarExtension: Placeholder,
    RootTreeWrapper,
    ExtraApplicationContainerComponents,
    ExtraApplicationContainerEditorWrapper: ExtraApplicationContainerApprovalsWrapper,
    CopilotCollaborationContextProvider: ContentEditorCopilotCollaborationContextProvider
  },
  infra: {
    rootUrl: '/knowledge-article/{portalId}/editor',
    rhumbConfig,
    lang
  },
  api: {
    API_BASE_URL: 'knowledge-content/v2/knowledge-articles',
    initialRequests: [initialRequestActions]
  },
  // Uses Redux's mapStateToProps pattern to get the TinyMCE config for the app
  // Must either be an object or a function that takes in the redux state and returns an object
  mapStateToTinyMCEConfig: () => {
    return {
      useEmbed: true,
      usePersonalization: true,
      useSourceCode: true,
      usePersonalizationAsUpgradePoint: false
    };
  }
});